import React, { useState, useEffect } from "react";
import { Outlet, Navigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Cookies from "universal-cookie";
import LoadingSpinner from "./LoadingSpinner";

const PrivateRouter = ({ isAuthenticated,handleLogout }) => {
  const cookies = new Cookies();
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showSidebarMobile, setShowSidebarMobile] = useState(false);
  const [cookiesLoaded, setCookiesLoaded] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setShowSidebarMobile(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const token = cookies.get("token");
    if (token) {
      setCookiesLoaded(true);
    } else {
      setCookiesLoaded(true);
    }
  }, []);

  const token = cookies.get("token");

  if (!cookiesLoaded) {
    return <LoadingSpinner />;
  }

  if (!token || !isAuthenticated) {
    return <Navigate to='/sistemaMBOX' replace />;
  }

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const toggleSidebarMobile = () => {
    setShowSidebarMobile(!showSidebarMobile);
  };

  return (
    <div style={{ display: "flex" }}>
      <Sidebar
        collapsed={collapsed}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
        showSidebarMobile={showSidebarMobile}
        toggleSidebarMobile={toggleSidebarMobile}
        handleLogout={handleLogout}
      />
      <div
        style={{
          marginLeft: isMobile ? "0" : collapsed ? "80px" : "250px",
          padding: "20px",
          width: "100%",
          transition: "margin-left 0.3s",
        }}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default PrivateRouter;
